import { createApp } from 'vue'
import VueCesium from 'vue-cesium'
//import lang from 'vue-cesium/lang/zh-hans'
import App from './App.vue'
import router from './router'

//把所有console.log關閉,DEBUG時要註解掉
console.log = function () {};

createApp(App).use(VueCesium).use(router).mount('#app');